import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppStore } from '@/store/useAppStore'
import { ROUTES } from '@shared/config/routes'

export const ProtectedRoute = () => {
  const location = useLocation()
  const isAuthenticated = useAppStore((s) => s.isAuthenticated)

  if (!isAuthenticated) {
    const redirect = location.pathname + location.search
    return <Navigate to={`${ROUTES.AUTH}?redirect=${encodeURIComponent(redirect)}`} replace />
  }

  return <Outlet />
}
